export const createSizing = () => ({
  tableRowHeight: 43,
});
